export class NotificationModel {

    constructor(
      public id: number,
      public type: NotificationType,
      public title: string,
      public timeout: number,
      public message?: string,
    ) { }
  
  }
  
  export enum NotificationType {
    Success = 'Success',
    Warning = 'Warning',
    Error = 'Error',
    Info = 'Information'
  }
  